<template>
  <div>
    <el-row :gutter="10">
      <el-col :span="16">
        <el-card class="box-border dense">
          <div slot="header">
            <el-date-picker
              v-model="ymd"
              type="month"
              placeholder="Year/Month"
              size="mini"
              :value-format="'yyyy-MM-dd'"
              :clearable="false"
              @change="loadData"
            />
          </div>
          <table class="gray">
            <thead>
              <tr>
                <th rowspan="2">Company</th>
                <th
                  v-for="(group, target) in stats.groups"
                  :key="target"
                  class="capitalize"
                  :colspan="Object.keys(group).length"
                >
                  {{ target }}
                </th>
              </tr>
              <tr>
                <slot v-for="(group, target) in stats.groups">
                  <th
                    v-for="(total, company) in group"
                    :key="target + company"
                    class="upcase"
                  >
                    {{ company }}
                  </th>
                </slot>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(tenant, index) in stats.tenants" :key="index">
                <td>{{ tenant.name }}</td>
                <slot v-for="(group, target) in stats.groups">
                  <td
                    v-for="(total, company) in group"
                    :key="target + company"
                    class="normal"
                  >
                    <a @click="showDetails(tenant, target, company)">{{
                      showTimes(tenant, target, company)
                    }}</a>
                  </td>
                </slot>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <th></th>
                <slot v-for="(group, target) in stats.groups">
                  <th
                    v-for="(total, company) in group"
                    :key="target + company"
                    class="normal"
                  >
                    <b class="fs14">{{ total }}</b>
                  </th>
                </slot>
              </tr>
            </tfoot>
          </table>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card class="box-border dense" v-if="current.tenant">
          <div slot="header" class="flex-space">
            <div>{{ current.tenant.name }}</div>
            <div class="capitalize">
              {{ current.target }} - {{ current.company }}
            </div>
          </div>
          <div class="fs14">Target Count</div>
          <v-table
            v-if="details.targets"
            :items="details.targets"
            :row-height="30"
            :defaultSort="{}"
            :getHeight="getHeight"
          >
            <template v-slot:tbody>
              <u-table-column prop="traceable_id" label="#ID">
                <template v-slot="scope">
                  {{ scope.row.traceable_id }}
                </template>
              </u-table-column>
              <u-table-column label="Times">
                <template v-slot="scope">
                  <el-popover placement="bottom" width="150" trigger="hover">
                    <ul class="circle">
                      <li
                        v-for="(timestamp, index) in scope.row.timestamps"
                        :key="index"
                      >
                        {{ timestamp }}
                      </li>
                    </ul>
                    <a slot="reference"> {{ scope.row.times }}</a>
                  </el-popover>
                </template>
              </u-table-column>
            </template>
          </v-table>
          <div class="fs14 mt10">Daily Count</div>
          <v-table
            v-if="details.daily"
            :items="details.daily"
            :row-height="30"
            :defaultSort="{}"
            :getHeight="getHeight"
          >
            <template v-slot:tbody>
              <u-table-column prop="traceable_id" label="#ID">
                <template v-slot="scope">
                  {{ scope.row.date }}
                </template>
              </u-table-column>
              <u-table-column label="Times">
                <template v-slot="scope">
                  <el-popover placement="bottom" width="400" trigger="hover">
                    {{ scope.row.ids.join(", ") }}
                    <a slot="reference"> {{ scope.row.times }}</a>
                  </el-popover>
                </template>
              </u-table-column>
            </template>
          </v-table>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  name: "Traces",
  data() {
    return {
      ymd: new Date(),
      stats: {
        groups: [],
        tenants: [],
      },
      totals: {},
      details: {},
      current: {},
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    getHeight() {
      return (
        (document.querySelector("#app > .content").offsetHeight - 170) / 2.0
      );
    },
    showTimes(tenant, target, company) {
      return (
        tenant.usage.find((o) => o.target == target && o.company == company) ||
        {}
      ).times;
    },
    loadData() {
      this.$http
        .get("/system/traces/stats.json", { params: { ymd: this.ymd } })
        .then((response) => (this.stats = response.data))
        .catch((err) => {});
    },
    showDetails(tenant, target, company) {
      this.current = { tenant, target, company };
      const subdomain = tenant.subdomain;
      const q = {
        created_at_from: this.stats.from,
        created_at_to: this.stats.to,
        company_type: target,
        company: company,
      };
      this.$http
        .get("/system/traces.json", { params: { subdomain, q } })
        .then((response) => (this.details = response.data))
        .catch((err) => {});
    },
  },
};
</script>